import React from 'react'
import { useParams, Link } from '@tanstack/react-router'
import { withPageProtection } from '@/lib/rbac/hoc'
import { PAGES } from '@/lib/rbac/constants'
import { Button } from '@/components/ui/Button'
import { LoadingSpinner } from '@/components/ui/LoadingSpinner'
import { RoleForm } from '@/components/workforce/RoleForm'
import { useRole } from '@/hooks/useWorkforce'
import { ArrowLeft, Briefcase } from 'lucide-react'

function EditRoleContent() {
  const params = useParams({ from: '/_auth/workforce/roles/$roleId/edit' })
  const roleId = params.roleId

  const { role, loading, error } = useRole(roleId)

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (error || !role) {
    return (
      <div className="text-center py-12">
        <p className="text-red-500 mb-4">{error || 'Cargo não encontrado'}</p>
        <Link to="/workforce/roles">
          <Button variant="outline">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar para Cargos
          </Button>
        </Link>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Link to={`/workforce/roles/${roleId}` as any}>
          <Button variant="ghost" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
        </Link>
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white flex items-center gap-3">
            <Briefcase className="w-8 h-8 text-brand-primary" />
            Editar {role.name}
          </h1>
          <p className="font-body text-brand-gray mt-2">
            Atualize as informações do cargo
          </p>
        </div>
      </div>

      {/* Form */}
      <RoleForm mode="edit" role={role} />
    </div>
  )
}

// Apply RBAC protection
export default withPageProtection(EditRoleContent, PAGES.WORKFORCE_ROLES)
